import { render, staticRenderFns } from "./MatchesSearchBar.vue?vue&type=template&id=68d2f53b&scoped=true"
import script from "./MatchesSearchBar.vue?vue&type=script&lang=js"
export * from "./MatchesSearchBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d2f53b",
  null
  
)

export default component.exports